export const states = ["Tripura"];

export const districtsByState = {
  Tripura: [
    "Dhalai",
    "Gomati",
    "Khowai",
    "North Tripura",
    "Sepahijala",
    "South Tripura",
    "Unakoti",
    "West Tripura",
  ],
};

export const offices = [
  "Supdt.of Taxes,Ambassa",
  "Supdt.of Taxes,Belonia",
  "Supdt.of Taxes,Bishalgarh",
  "Supdt.of Taxes,Charge-I",
  "Supdt.of Taxes,Charge-II",
  "Supdt.of Taxes,Charge-III",
  "Supdt.of Taxes,Charge-IV",
  "Supdt.of Taxes,Charge-V",
  "Supdt.of Taxes,Charge-VI",
  "Supdt.of Taxes,Charge-VII",
  "Supdt.of Taxes,Charge-VIII",
  "Supdt.of Taxes,Dharmanagar",
  "Supdt.of Taxes,Kailashahar",
  "Supdt.of Taxes,Khowai",
  "Supdt.of Taxes,Sonamura",
  "Supdt.of Taxes,Teliamura",
  "Supdt.of Taxes,Udaipur"
];

export const registrationTypes = [
  "VOLUNTARY",
  "MANDATORY"
];

export const businessStatuses = [
  "Proprietary",
  "Unregistered Partnership",
  "Registered Partnership",
  "Private Limited Company",
  "Public Limited Company",
  "Public Sector Undertaking",
  "Statutory Body",
  "Co-operative Society",
  "Trust",
  "Hindu Undivided Family(HUF)",
  "Other",
  "Government Department",
  "Association of Persons"
];

export const occupancies = [
  "Owned",
  "Rented",
  "Leased",
  "Rent-Free",
  "Others"
];

export const statutoryAuthorities = [
  "REGISTER OF COMPANIES",
  "REGISTER OF FIRMS",
  "DEPT OF INDUSTRY & COMMERCE",
  "DEPT OF CENTRAL EXCISE",
  "DEPT OF STATE EXCISE",
  "DEPT OF IMPORTS & EXPORTS",
  "OTHERS",
];

export const commodities = [
  "Acetals and hemiacetals",
  "Acid",
  "Acrylic polymers",
  "Activated carbon",
  "Adhesives, Vulcanizing solution, resin",
  "Advertisement hoarding",
  "Aerated water, soda water, mineral water",
  "Aerials, antennas and parts",
  "Aeroplanes, aircrafts, gliders, flying machines, parts & accessories",
  "Agricultural implements manually operated or animal driven",
  "Agricultural implements not operated manually or not driven by animal",
  "Aids and implements used by handicapped persons",
  "Air conditioning plants, air conditioner, parts & accessories",
  "Air cooler, room cooler, water cooler cum heater units & spares",
  "Air pollution control equipments",
  "Air purifiers",
  "Album",
  "Aldehydes whether or not with other oxygen function",
  "Alfa Olefin Sulphonate",
  "Alkali or alkaline earth metals",
  "All bangles (except those of precious metals)",
  "All immitation Jewellery",
  "All kinds of plate & sleeper bars & rails",
  "All kinds of utensils",
  "All processed Fruits & vegetables",
  "All types of yarn other than cotton and silk yarn in hank and sewing thread",
  "All varieties & forms of wires & wire rods",
  "All varieties of tin & tin free plates",
  "Alloys",
  "Alluminun conductor steel reinforced (ACSR)",
  "Alluminun in any shape or forms, its alloys and products",
  "Aluminium hydroxide",
  "Aluminium ores and concentrates",
  "Amino-function compounds",
  "Amino-resins, polyphenylene oxide",
  "Ammonia, anhydrous",
  "Animal Hair",
  "Animal including fish fats, oils, crude, refined or purified",
  "Animal or vegetable fats boiled, oxidised, dehydrated etc.",
  "Anti-bed sore",
  "Apparatus for making coffee",
  "Aquatic feed",
  "Arecanuat powder",
  "Arms,ammunitions",
  "Articles for conveyance or packing of goods of plastics",
  "Articles made of fur",
  "Articles made of horn, coconut shell",
  "Articles made of leather",
  "Articles made of other woods",
  "Articles made of skin",
  "Articles made of straw, bamboo, cane",
  "Articles of aluminium",
  "Articles of brass",
  "Articles of bronze",
  "Articles of cadmium",
  "Articles of copper",
  "Articles of Gold/silver/precious metals & jewellery",
  "Articles of lead",
  "Articles of Zinc",
  "Articles, equipments for gymnastics",
  "Artificial graphite",
  "Artificial silk yarn",
  "Asbestos sheets and products",
  "Asphaltic roofing",
  "Astronomical instruments",
  "Aviation Gasoline/ Aviation turbine fuel and all other varienties of fuel for air crafts",
  "Bagasse",
  "Baking powder",
  "Bamboo",
  "Bamboo converted to sticks for manufacture of Agarbathi",
  "Bases",
  "Basic chromium shulphate",
  "Batteries & parts",
  "Bearing",
  "Bearings",
  "Beauty boxes",
  "Beds made of cotton or silk cotton",
  "Bedsheets, pillow cover and other made ups",
  "Beedi leaves",
  "Beltings",
  "Benzole",
  "Betel leaves",
  "Betel nut",
  "Bhog or mahabhog by religious institutions",
  "Bicycles and parts & tyre, tube thereof",
  "Bidi",
  "Bindi",
  "Binding Cloth",
  "Binoculars",
  "Biomass Briquettes",
  "Biscuits of all varieties",
  "Bitumen",
  "Bitumen (Industrial Input)",
  "Black board",
  "Black board duster",
  "Black lead",
  "Blanket, woolen shawl, embroidered cloth",
  "Blasting gun powder",
  "Bleach liquid",
  "Bleaching powder",
  "Blood component",
  "Blood plasma",
  "Boards of all kinds, wall ceiling",
  "Boards of all types",
  "Boilers",
  "Bone meal",
  "Books, periodical and journals",
  "Borates, peroxoborates",
  "Bread except pizza bread containing any type of fruit or vegetables",
  "Bread improver",
  "Bricks",
  "Buckets",
  "Buldozers, parts & accessories",
  "Bulk drugs",
  "Butadine",
  "Button cells",
  "C.P. accessories",
  "Cables of all types",
  "Cake gel",
  "Calcium carbides",
  "Candle",
  "Capital goods",
  "Carbon (carbon blacks & other forms of carbon)",
  "Carbonates, peroxocarbonates",
  "Carboxyamide–function compounds including saccharin and its salts",
  "Carboxyamide–function compounds",
  "Carboxylic acids",
  "Carboys, bottles, jars, phials of glass",
  "Cartons, Boxes",
  "Casein, Caseinates",
  "Casseroles",
  "Castings of all metals",
  "Castrol oil",
  "Cathode ray oscilloscopes, Spectrum analysers, Signal analysers",
  "Cattle feed, animal feed including supplement and husk of pulses, concentrate and additives, wheat bran, grass hey and straw cellulose and its chemical derivatives",
  "Cement & its substitute",
  "Cement concrete mixture",
  "Cement products",
  "Chalk stick",
  "Charcoal",
  "Charkha",
  "Chemical elements doped",
  "Chemical Fertilizer & Biofertilizer",
  "Chemicals",
  "Chemicals used in photographic development and printing",
  "Cheroot",
  "Chewing gum",
  "Chewing tobacco",
  "Chicory",
  "Chinaware",
  "Chlorates and perchlorates, Bromates etc.",
  "Chlorides, chloride oxides",
  "Chromium ores and concentrates",
  "Chromium oxides and hydroxides",
  "Cigar",
  "Cigar cases & cigarette cases",
  "Cigarette",
  "Cigarette filter",
  "Cinematographic equipments, parts & accessories",
  "Citronella oil",
  "Clay of all varieties",
  "Clinker",
  "Clip boards",
  "Clutch pencils",
  "Coal",
  "Coal boiler ash",
  "Coal cinder ash",
  "Coal powder",
  "Coaltar",
  "Coarse grains other than paddy, rice and wheat",
  "Cobalt ores and concentrates",
  "Cobalt oxides and hydroxides",
  "Cocoa",
  "Coconut in shell & separated kernal of coconut other than kopra",
  "Coconut oil",
  "Coconut products",
  "Cocoon and raw silk",
  "Coffee beans and seeds",
  "Coffee drink",
  "Coffee powder",
  "Coir & Coir products",
  "Coke",
  "Cold storage plants, equipments & parts",
  "Collapsible gate & parts",
  "Collapsible gates",
  "Colour lakes",
  "Coloured matches",
  "Colouring matter of vegetable or animal origin",
  "Comb",
  "Components & spare parts of motor vehicle",
  "Components & spare parts of motor vessels, motor engine, trailers",
  "Components& spare parts of motor cycles, scooters, mopeds, motorettes",
  "components, spare parts and accessories of such machine",
  "Compounded rubber, unvulcanised",
  "Compounds, inorganic or organic of ratre earth metals",
  "Computer cleaning kit",
  "Computer stationery",
  "Computer systems and peripherals, Electronic diaries",
  "Condoms & contraceptives",
  "Conduit pipe & its fittings",
  "Confectionery items",
  "Cooked food",
  "Cooking gas",
  "Copper ores and concentrates",
  "Copper sulphate",
  "Cosmetics",
  "Cottage cheese",
  "Cotton & silk yarn in hank",
  "Cotton and cotton waste",
  "Creosole oils",
  "Crucibles",
  "Crude Oil",
  "Cup and Glasses of paper",
  "Cupboard fresheners",
  "Cups and Glasses of plastic",
  "Curd, lussi,butter milk & separated milk",
  "Cushions",
  "Cyanides, cyanide oxides",
  "Cyclic alcohols",
  "Cyclic Hydrocarbons",
  "D C Micromotors, Stepper motors of 37.5 watts",
  "DATA/Graphic Display tubes, other than Picture tubes and parts",
  "Date stamps",
  "De-oiled cake",
  "Decam hem products",
  "Declared goods under CST Act'56",
  "Decorative sheets",
  "Defectives, rejects, cuttings or end pieces of iron & steels",
  "Dehydrated/Processed vegetables",
  "Denatured ethyl alcohol of any strength",
  "Denatured spirit, rectified spirit",
  "Deodorizers",
  "Detergents",
  "DI-Ethylene Glycol, Mono-Ethylene Glycol",
  "Diaper/nappies",
  "Diapers",
  "Diazo-, Azo- or azoxy-compounds",
  "Diesel",
  "Diesel engine & spare parts",
  "Diesel locomotive and parts andaccessories",
  "Diffraction apparatus",
  "Diluents & thinners",
  "Diodes, transistors & similar semi-conductor devices",
  "Diphosphorous penataxide, phosphoric acid etc.",
  "Dippers, parts & accessories",
  "Disinfectants",
  "Distilled water, medicinal water, ionic water",
  "Dithionites and sulphoxylates",
  "Dolomite",
  "Doors, Windows, Ventilators, Partitions, Stands, Ladders",
  "Dry cells & parts",
  "Dry fruits",
  "Dummy code needs to be deleted",
  "Dumpers, parts & accessories",
  "Duplicating machines, Parts & accessories",
  "Dusters",
  "Dyes",
  "Earth movers, parts & accessories",
  "Earthen Tiles",
  "Earthern pot",
  "Edible gelatin",
  "Edibles oils",
  "Egg preserved and sold in air tight containers",
  "Eggs & livestock and animal hair",
  "Electric motors, spare parts & accessories",
  "Electrical apparatus for line telephony or line telegraphy",
  "Electrical appliances",
  "Electrical capacitors, fixed, variable and parts",
  "Electrical commercial appliances",
  "Electrical energy",
  "Electrical goods",
  "Electrical resistors",
  "Electrodes",
  "Electronic calculators",
  "Electronic goods",
  "Electronic Integrated Circuits and Micro-assemblies",
  "Electronic Toys",
  "Electroplated nickel",
  "Elevators",
  "Embroidery machines, needles",
  "Embroidery or zari articles",
  "Empty gas cylinders",
  "Enzymes, Prepared enzymes",
  "Equipments for Communications",
  "Esters of other inorganic acids",
  "Ethers, ether-alcohols, ether-phenols etc.",
  "Ethylene Diamine Tetra Acetic Acid",
  "Ethylene Oxide",
  "Ethylene, Propylene",
  "Excavators, parts & accessories",
  "Exercise books",
  "Expanded polystyrene",
  "Explosive of all kinds",
  "Exposed films",
  "Expoxides, epoxyalcohols, epoxyethers",
  "Fax machines, parts & accessories",
  "Feeding bottle & Nipple",
  "Ferrous and non-ferrous metals and alloys",
  "Fibreglass's articles",
  "Fibreglass sheets",
  "Fibres of all types and fibre waste",
  "Finishing agents, fixing of dye-stuffs",
  "Fire Clay coal ash",
  "Fire fighting equipments",
  "Fire works",
  "Firewood",
  "Fish not cured or frozen",
  "fishnet & fabrics, fish seeds/prawn/shrimp seeds",
  "Flash light apparatus",
  "Flexible plain films",
  "Floor coverings",
  "Floor, wall & roof tiles",
  "Flour, atta, maida, suji and besan",
  "Fluirides, fluorosilicates, etc.",
  "Flurine, chlorine, bromine and iodine",
  "Fly ash",
  "Foam rubber products",
  "Food Colours & essences",
  "Foods and food preparation",
  "Footwear",
  "Fresh flowers",
  "Fresh milk",
  "Fresh plant",
  "Fresh vegetables & fruits",
  "Fried/roasted / salted Grams & kernels",
  "Fruit Drinks/concentrate/syrup/cordial/juice",
  "Fruit oils",
  "Fruit paste",
  "Fruits preserved and sold in air tight containers",
  "Fruits sold in preserved form",
  "Fulminates, cyanates and thiocyanates",
  "Fur",
  "Furnaces",
  "Furniture & parts",
  "Gadgets & parts & accessories of mosquito & insect repellents",
  "Garden umbrellas & beach umbrellas & parts",
  "Garlic & ginger",
  "Garnet sand",
  "Gas cylinder",
  "Gas stove & parts & accessories",
  "Gases",
  "Generators & spare parts",
  "Geometry boxes, Colour boxes & Crayons",
  "Glass & glassware",
  "Glass frit and other glass",
  "Glycerine",
  "Glycerol, crude, glycerol waters and glycerol lyes",
  "Glycosides, natural or reproduced by synthesis and their salts",
  "Goods taken under customs bond for re-export after manufacturing or otherwise",
  "Granulated slag (slag sand) from mfg. Of iron or steel",
  "Graph book",
  "Greeting cards, Invitation Cards",
  "Grills made of iron & steel",
  "Gur and Juggery and edible variety of rub gur",
  "Gutka",
  "Hair",
  "Hair creams",
  "Hair dyes",
  "Hair oil",
  "Hair removers",
  "Hair sprayers",
  "Halides and halide oxides of non-metals",
  "Halogenated derivatives of Hydrocarbons",
  "Halogenated, sulphonated derivatives of products",
  "Halogenated, sulphonated, nitrated derivatives of phenols alcohols",
  "Hand bags",
  "Hand pump and spare parts",
  "Handicrafts",
  "Handloom machinery & parts & accessories",
  "Handlooms and handloom fabrics, gandhi topi",
  "Hardwares",
  "Harvesters and parts",
  "Havan Samagri, dhoop Sambrani & lobhana",
  "HDPE",
  "Health fitness equipments",
  "Helicopters, parachutes, dirigibles",
  "Helmet",
  "Herb, bark, jarl booti & dry flower",
  "Heterocyclic compounds with nitrogen heteroatom(s) only",
  "Heterocyclic compounds with oxygen heteroatom(s) only",
  "Hides & Skin",
  "Hing (Asafoelida)",
  "Hoists",
  "Hollow polyster fibre",
  "Honey",
  "Hookah",
  "Hose pipes & fittings thereof",
  "Hosiery goods",
  "Hospital instruments, apparatus, appliances, tools and aids",
  "Human blood",
  "Husk and bran of cereals",
  "Hydrazine & hydroxylamine and their inorganic salts",
  "Hydrogen chloride",
  "Hydrogen, rare gases & other non-metals",
  "Hydroxide and peroxide of magnesium",
  "Ice",
  "Ice-cake",
  "Ice-candy",
  "Ice-jelly",
  "Ice creams",
  "Idols made of clay",
  "Incense sticks",
  "Index file clips",
  "Indigenous handmade musical instruments",
  "Industrial Cables",
  "Industrial monocarboxylic fatty acids",
  "Insecticides, pesticides, herbicides, weedicides,etc.",
  "Instant coffee",
  "Instant tea",
  "Insulated flexible air ducts",
  "Insulators",
  "Intangible goods",
  "Internal combustion engine & spare parts",
  "Ion-exchangers based on polymers",
  "Iron & Steel",
  "Iron oxides and hydroxides",
  "Iron scrap, cast iron scrap",
  "Isotopes and compounds",
  "IT software or any media",
  "item covered by PDS (except kerosine)",
  "Ivory articles",
  "Jam jelly, pickels, squash.",
  "Journals",
  "Jute",
  "Jute-cum-polypropylene coverings",
  "Jute Batching Oil (C)",
  "Jute Batching Oil (P)",
  "Katha",
  "Kerosine lamp / Lantern, petomax & Glass chimney",
  "Kerosine oil sold through PDS",
  "Kerosine stove",
  "Key chains",
  "Key holders",
  "Khandsari",
  "Khoya / Khoa",
  "Kitchenware",
  "Knitting wool",
  "Kulfi",
  "Kumkum",
  "Laboratory note book",
  "Laboratory reagents",
  "Ladders",
  "Laminated board",
  "Laminated sheets",
  "Laundry brighteners, Blue",
  "LCD Panels, LED panels and parts.",
  "Lead ores and concentrates",
  "Leather goods",
  "Leaves oil",
  "Lenses",
  "Lifts",
  "Light liquid paraffin of IP grade",
  "Light roofing sheets",
  "Lighter of all kinds",
  "Lignite",
  "Lime & lime products",
  "Lime stone",
  "Linear alkyl benzene, LAB",
  "Liquid Crystal devices, flat panel display devices and parts",
  "Liquid glucose (non-medicinal), Dextrose syrup",
  "Liquified petroleum gas other than for domestic use.",
  "Liquified Petrolium Gas for domestic use",
  "Liquor",
  "LLDPE/LDPE",
  "Lock, padlock & keys",
  "Lottery Tickets",
  "Low sulphur heavy stock",
  "Lubricants",
  "Machine, Machinery, plant, equipment, apparatus, tools, appliances",
  "Machinery of all kinds",
  "Magnifying glass",
  "Maize gem",
  "Maize products",
  "Maize starch",
  "Manganese ores and concentrates",
  "Manganese oxides.",
  "Marble & articles of marbles",
  "Margarine",
  "Marine engine & spare parts",
  "Matting materials",
  "Mattress",
  "Measuring devices",
  "Meat not cured or frozen",
  "Mechanical explosive",
  "Mechanical instruments",
  "Mechanical wood pulp, chemical wood pulp, semi-chemical wood pulp",
  "Medical imaging equipments",
  "Medicine & Drugs including Vaccine & medicated ointment",
  "Medical equipment / Devices / implants",
  "Menthol",
  "Mercury",
  "Metal of all types & forms",
  "Metal scraps",
  "Metallic products",
  "Methanol",
  "Methyl alcohol, Ethyl alcohol",
  "Micro cellular rubber",
  "Micronutrients, plant growth promoters & regulators",
  "Microphones, multimedia speakers, headphones etc.",
  "Microscope",
  "Milk food",
  "Milk products",
  "Miscellaneous items not covered in any other shedule",
  "Mixed alkylbenzenes.",
  "Mixed PVC stabilizer",
  "Molasses",
  "Molybdenum ores and concentrates",
  "Monoculars",
  "Mosaic tiles, chips & Powder",
  "Mosquito & insect repellents",
  "Mosquito net",
  "Motor coolant, solvent oil & transformer oil",
  "Motor cycles, motor combinations, motor scooter, mopeds, motorettes",
  "Motor vehicle, chasiss of motor vehicle",
  "Motor vessels, motor engine, trailers, motor bodies",
  "Moulded plastic footwear, hawai chappals & straps",
  "Moulds and dies",
  "Mouth washes/deodrants",
  "Mushroom",
  "Musical instruments",
  "Napa slabs",
  "Naphtha",
  "Naphthols",
  "Napthalene",
  "Narcotics",
  "National Flag",
  "Natural & synthetic essential oils",
  "Natural polymers.",
  "Natural rubber, balata, gutta percha.",
  "Neera and arak",
  "Neutral spirit",
  "Newars",
  "Newsprint",
  "Nickel ores and concentrates",
  "Niobium, tantalum, vanadium or zirconium ores and concentrates",
  "Nitric acid, sulphonitric acids",
  "Nitrile-function compounds.",
  "Nitrites, nitrates",
  "Non-judicial stam paper sold by government treasuries",
  "Non-metals such as alluminium,copper,zinc & extrusions of those.",
  "Non-soft Boards or Insulating Material made of any other Material other than wood",
  "Non alcholic beverages",
  "Non mechanised boats",
  "Normal Paraffin",
  "Nucleic acids and their salts.",
  "Nut, Bolts, Screw & Fasteners",
  "Office files",
  "Office machines, equipments & apparatus",
  "Oil cake",
  "Oil engine & spare parts",
  "Oil Seeds",
  "Opera glasses",
  "Optical fibre and optical fibre bundles, cables",
  "Optical fibre cables",
  "Optical goods, parts & accessories",
  "Optical instruments & lenses",
  "Optical whitening agents",
  "Ores & minerals",
  "Organic derivatives of hydrazine or of hydroxylamine.",
  "Organic manure",
  "Organo-sulphur compounds.",
  "Other",
  "Other aquatic products not cured or frozen",
  "Other ores and concentrates",
  "Other parts & accessories used in photography",
  "Oxides of boron, boric acids",
  "Oxygen - function amino-compounds.",
  "Packing cases & materials",
  "Packing Materials",
  "Paddy, rice, wheat & pulses",
  "Paint brushes",
  "Paints remover & stainer",
  "Paints, lacquers, polishes, enamels, colours, varnishes, primers of all kinds",
  "Palm fatty acid",
  "Pan chutney",
  "Pan masala",
  "Papad",
  "Paper",
  "Paper and cloth used in photography",
  "Paper Board",
  "Paper cutter",
  "Paper envelopes",
  "Paper pin/ Stapler pin/pen stand/pencil lead/markers, rulers",
  "Paper printed labels, paperboard printed labels.",
  "Paper self-adhesive tape.",
  "Paraffin wax- food grade standard",
  "Paraffin wax except food grade standard",
  "Partially oriented yarn, polyester texturised yarn.",
  "Partitions",
  "Parts & accessories of motor",
  "Parts & accessories of pump",
  "Parts and Accessories of HSN 84.69, 84.70 & 84.71",
  "Parts and accessories of machineries and tools used there with",
  "Parts and accessories of measuring devices",
  "Parts of HSN 85.01",
  "Pasteurised milk",
  "Pencil Sharpner",
  "Pens & refills",
  "Perambulator & its spare parts, accessories & components",
  "Permanent magnets and articles",
  "Pestle (sheel nora)",
  "Petrochemicals",
  "Petrol",
  "Petrol and Diesel additives",
  "Petroleum resins.",
  "Petrolium products",
  "Phonols",
  "Phosphides,whether or not chemically defined.",
  "Phosphinates, phosphonates, etc.",
  "Phosphoric ester and their salts.",
  "Photo albums, stamp, photo frames",
  "Photo copying machines, Parts & accessories",
  "Photo Frames",
  "Photographic cameras & enlargers, lenses & films",
  "Pig iron, cast iron",
  "Pillows",
  "Pillows made of cotton or silk cotton",
  "Pipe-layers, parts & accessories",
  "Pipe holders",
  "Pipes of all varities including fittings",
  "Plaster of Pairs",
  "Plastic foam products",
  "Plastic granules/Powder & master batches",
  "Plastics Sheets and articles made thereof",
  "Playing Cards",
  "Plywood, Vener Plywood",
  "Pokers",
  "Pollution control equipments",
  "Pollution Control Equipments & Parts & Accessories",
  "Pollution Control instrumentation",
  "Poly Propylene and Articles made thereof",
  "Polyacetals.",
  "Polyanides.",
  "Polycarboxylic acids.",
  "Polyester Staple Fibre & Polyester Staple Fibre Fill.",
  "Polyester Staple Fibre waste.",
  "Polymers of propylene.",
  "Polyster fibre Yarn",
  "Polysterene and Articles made thereof",
  "Polythene and Articles made thereof",
  "Polythene chips",
  "Polyvinyl Chloride and Articles made thereof",
  "Porcelain ware",
  "Porridge",
  "Postal items like envelop, post card etc. sold by government",
  "Potassium dischromate.",
  "Poultry feed",
  "Powder for food drink",
  "Power Driven Pumps & Parts & Accessories",
  "Power Factors",
  "Prasadam",
  "Prawn not cured or frozen",
  "Pre-owned Car or Used Car",
  "Precious metal ores and concentrates",
  "Precious Metals, gold, silver",
  "Precious stones",
  "Prepared rubber accelerators.",
  "Prepared unrecorded media for sound recording",
  "Pressure cooker / Pan",
  "Printed Circuits",
  "Printed driers.",
  "Printed material - Diary, calendar etc.",
  "Printing ink",
  "Printing ink whether concentrated or solid.",
  "Printing materials, press materials",
  "Processed Meat, Fish, Poultry",
  "Products of mixture of rubber and synthetic rubber",
  "Puffed rice, muri, chira, khoi, murki",
  "Pulp",
  "Pulp moulded product & paper products",
  "Pump & Motor",
  "Pumps and parts",
  "Purses, hand bags, vanity bags/boxes, cases",
  "PVC",
  "PVC cloth product",
  "Pyrogenic metal powders",
  "Quaternary ammonium salts and hydroxides.",
  "Quilts made of cotton or silk cotton",
  "Radio communication receivers, Radio Pagers, DVD and CD",
  "Radioactive chemical elements.",
  "Rail coaches, Engines, wagons & parts & accessories thereof",
  "Railway coaches engine, wagon & parts",
  "Rain coat",
  "Rakhi",
  "Raw hides and Skins.",
  "Raw Jute.",
  "Raw rubber of all grades/ types including latex and scrap.",
  "Raw wool",
  "Reaction initiators, reaction accelerators.",
  "Readymade garments",
  "Reclaimed rubber, synthetic rubber",
  "Reducers and blanket wash/roller wash.",
  "Refractory and refractory materials",
  "Refractory monolithic",
  "Refrigerator and parts accessories",
  "Reinforced safes, strong boxes, chest, wall coffers, lockers, cabinets",
  "Religious pictures not for use as calender",
  "Renewable energy devices and spare parts",
  "Reprographic copiers, Parts & accessories",
  "Residual lyes from mfg. Of wood pulp.",
  "Retarders.",
  "Rexin products",
  "Ribbons",
  "Rice bran",
  "Rickshaw and parts & tyre, tube thereof",
  "River sand",
  "Rolling shutters & parters",
  "Rolling shutters and parts",
  "Rosewood articles",
  "Rosin and resin acids and derivatives.",
  "Rough synthetic gem boules",
  "RTS grills",
  "Rubber of all grades/types",
  "Rubber products",
  "Rupee note when sold to Reserve Bank of India & cheques",
  "Saccharine",
  "Sacks and bags, of a kind used for packing of goods.",
  "Sacred thread",
  "Safety matches",
  "Saffron",
  "Sago",
  "Salt",
  "Sandalwood articles",
  "Sandalwood oil, Ramachom oil, cinnamon oil",
  "Sanitary towel/napkins",
  "Saplings",
  "Saturated acyclic monocarboxylic acids.",
  "Scanners",
  "Scented supari",
  "Scientific instrument & lab. Equipments",
  "Scrappers & the like, parts & accessories",
  "Sea food preserved and sold in air tight containers",
  "Seat cover",
  "Seeds of all varieties other than those specified elsewhere in any other schedule.",
  "Self-adhesive plates, sheets, film, strip of plastics.",
  "Semen including frozen semen",
  "Semi cooked or semi processed food stuffs",
  "Sewing machines, Parts & accessories",
  "Sewing thread",
  "Shahabad Stone",
  "Shampoo/Body deodorants",
  "Shaving brush/cream/soap/lotion",
  "Shaving set, razor, blades, cartridge",
  "Sheet, hoops, strips & skelp- black & galvanised, plain & corrugated",
  "Ship and other water vessels",
  "Shoe polish & whitener",
  "Shunt Capacitors",
  "Signal Generators and parts",
  "Silicons.",
  "Silk fabrics",
  "Silk worm layign",
  "Silverware",
  "Sinour",
  "Skelp iron steel bars, iron & steel bars in any shape & forms",
  "Skinned Milk Powder and UHT Milk",
  "Skins with fur",
  "Slate and slate pencils",
  "Smoking mixture for pipe and cigarette",
  "Snuff",
  "Sodium bi-chromate",
  "Sodium dischromate.",
  "Sodium hydroxide (caustic soda), Potassium hydroxide (caustic potash)",
  "Soft drinks, health drinks",
  "Solar cells & parts & accessories",
  "Solvent oil",
  "Sound recording & reproducing equipments, parts & accessories",
  "Sound transmitting equipments, spare parts & accessories",
  "Soya milk",
  "Spectacals, Parts & components, lens and lens cleaner",
  "Spices of all varieties and forms",
  "Sports goods",
  "Spriulina products",
  "Stain busters",
  "Stain removers",
  "Stainless steel products excluding utensils",
  "Stainless steel sheets",
  "Stands",
  "Staple fibre yarn",
  "Starch",
  "Steel semis",
  "Steel structurals including angles, joists, channels, tees etc.",
  "Steel tubes & fittings",
  "Stone Slab",
  "Stone/granite slab/block",
  "Stoneware articles",
  "Stong room or vault door & ventilators",
  "Stop watches, mechanical timers, instrumental clocks of all kinds and its parts & accessories",
  "Stoppers, caps and lids.",
  "Storage tanks",
  "Studio backgrounds including control reflectors, modifiers",
  "Sugar imported from out side India",
  "Sugar Manufactured or made in India.",
  "Suit cases, brief cases, attache, trunks",
  "Sulphides of non-metals",
  "Sulphides, Polysulphides.",
  "Sulphites, thiosulphates",
  "Sulphonamides.",
  "Sulphonated, nitrated or nitrosated derivatives of hydrocarbons.",
  "Sulphonic Acid, Alfa Olefin sulphohnate",
  "Sumnica, formica, copper-clad board or sheet",
  "Supplemental diet products",
  "Survey instruments",
  "Sweets",
  "Sweets & sweet meat",
  "Switches, Connectors, Relays for up to 5 amps",
  "Synthetic foam products",
  "Synthetic gems",
  "Synthetic organic colouring matter.",
  "Synthetic organic tanning substances.",
  "Synthetic rubber and factice derived from oils.",
  "Synthetic rubber products",
  "Syringes & dressing",
  "Tabulating/caculating machines, its products and accessories",
  "Tailoring materials",
  "Tamarind seed & powder",
  "Tampous",
  "Tanning barks",
  "Tanning extracts of vegetable origin.",
  "Tarpaulin",
  "Tea",
  "Telecommunication apparatus & ribbons",
  "Telephone answering machines, Cell phone",
  "Telephone, teleprinter and wireless equipment and parts thereof",
  "Telescope",
  "Television set, its component parts and accessories",
  "Tender green coconut",
  "Textile fabrics made wholly or partly of cotton, rayon, artificial silk or wool, manufactured or made in india.",
  "Textile imported from out side india",
  "Theodolite",
  "Thermally insulated flasks, containers its parts & accessories",
  "Three wheelers, parts & accessories",
  "Threshers and parts",
  "Timber",
  "Tin ores and concentrates",
  "Titanium ores and concentrates",
  "Titanium oxides.",
  "Tobacco",
  "Tobacco pipes",
  "Tobacco for hookah.",
  "Toddy",
  "Toilet soap",
  "Toluole",
  "Tonics, food supplement, appetizers, dietical foods & all other preparations",
  "Tools",
  "Tooth paste/powder/other dentrifices, tooth brush",
  "Torch light & bulbs",
  "Towel",
  "Toys",
  "Tractor and parts",
  "Transmission apparatus other than apparatus for radio or T.V. broadcasting",
  "Transmission towers",
  "Transmission wires",
  "Transport equipments",
  "Tricycle and parts & tyre, tube thereof",
  "Tubes and Pipes and fittings thereof",
  "Tungsten ores and concentrates",
  "Turpentine oil, bale oil, white oil, linseed oil, stand oil, parilla oil, whate oil, tung oil",
  "Typewriters and parts, ribbon & correction fluid",
  "Tyres/tubes/flaps-other than those for by/tri-cycle/rickshaw & wheel Chair",
  "Umbrella",
  "Uninterrupted power supply",
  "Unmanufactured Tobacco",
  "Unprocessed green leaves of tea",
  "Unsaturated acyclic monocarboxylic acids.",
  "Uranium or thorium ores and concentrates",
  "Vaccum flask of all kinds & its parts & accessories",
  "Vanaspati",
  "Veeneers",
  "Vegetable alkaloids,natural or reproduced by synthesis and their salts",
  "Vegetable oil",
  "Vegetable waxes, bees wax etc.",
  "Vegetables preserved and sold in air tight containers",
  "Vegetables, Mineral & other preparation in liquid,pill or powder forms",
  "Ventilators",
  "Vinegar",
  "Visitors Cards both blank and printed, Humour card, Picture card, Picture post cards.",
  "Watches, clocks time pieces/its parts, accessories, bands, straps & chains",
  "Water filter",
  "Water filter of all varities and descriptions",
  "Water not mentioned elsewhere",
  "Water proof cloth products",
  "Water proofing, damp proofing & weather proofing compounds",
  "Water sold in sealed containers or pouches",
  "Water supply and sanitary equipments and fittings of every description its parts & accessories",
  "Wear parts",
  "Weedicides, herbicides & rodenticides",
  "Weighing machines of all kinds and parts and accessories",
  "Welding rods and Electrodes",
  "Wet dates",
  "Wheat gluten",
  "wheels tyres, axles & wheel sets",
  "White Cement",
  "White washing materials",
  "Wigs",
  "Windows",
  "Wireless reception instruments and apparatus",
  "Wood tar, wood tar oils.",
  "Wooden Crates",
  "Word processing machines, Electronic typewriters",
  "Works Contract which are in the nature of printing works",
  "Writing Ink",
  "Writing instruments",
  "X-ray machine, X-ray films",
  "Xylole",
  "Yeast cell wall",
  "Yeast extract-paste or powder",
  "Yeast fresh, dried or compressed",
  "Zinc ores and concentrates"
];

export const bankOptions = [
  "Agartala Cooperative Urban Bank Ltd.",
  "Allahabad Bank",
  "Andhra Bank",
  "Axis Bank",
  "Bank of Baroda",
  "Bank of India",
  "Bank of Maharashtra",
  "Canara Bank",
  "Central Bank of India",
  "CITIBANK",
  "Corporation Bank",
  "Dena Bank",
  "FEDERAL BANK",
  "HDFC Bank",
  "Hongkong Shanghai Banking Corp.Ltd.",
  "ICICI Bank",
  "IDBI Bank",
  "Indian Bank",
  "Indian Overseas Bank",
  "Indus Bank",
  "Oriental Bank of Commerce",
  "Punjab and Sind Bank",
  "Punjab National Bank",
  "South Indian Bank Ltd.",
  "Standard Chartered Bank",
  "State Bank of India",
  "Syndicate Bank",
  "Tripura Gramin Bank",
  "Tripura State Co-operative Bank Ltd.",
  "Union Bank of India",
  "United Bank of India",
  "United Commercial Bank",
  "Vijaya Bank",
  "Yes Bank"
];
